import { RouteObject } from "react-router-dom";
import { TEAM, TEAM_MEMBERS } from "constants/urls";

export default [
  {
    index: true,
    path: TEAM,
    lazy: () => import("modules/team/pages/Team"),
  },
  {
    path: TEAM_MEMBERS,
    lazy: () => import("modules/team/pages/TeamMembers"),
  },
] as RouteObject[];
